/** True when axios/fetch aborted the request (e.g. React Strict Mode effect cleanup). */
export function isCanceledRequest(err) {
  return err?.code === 'ERR_CANCELED' || err?.name === 'CanceledError';
}
